import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import { resolve, reject } from 'q';

import { environment } from "../../environments/environment";
import { encode } from 'punycode';
import { BehaviorSubject } from 'rxjs';
// import { AlertService } from './alert.service';

@Injectable()
export class SurveyService {
    constructor(private http: HttpClient) { };
    private il = new BehaviorSubject<string>('');
    inventory = this.il.asObservable();
    public getSurveyList(data) {
        const getSurveyListObservable = new Observable(observer => {
            this.http.get(`${environment.API_HOST}/survey?page=${data.page}&offset=${data.offset}&where=${data.where}&startDate=${data.startDate}&endDate=${data.endDate}`)
            .subscribe(response => {
                observer.next(response);
            }, error => {
                observer.next(error.reason);
            })
        });
        return getSurveyListObservable; 
    } // prifle end*/
    public getSurveyEmployee(form,user) {
        const getSurveyEmployeeObservable = new Observable(observer => {
            this.http.get(`${environment.API_HOST}/survey/show/${form}/${user}`)
            .subscribe(response => {
                observer.next(response);
            }, error => {
                observer.next(error.reason);
            })
        });
        return getSurveyEmployeeObservable; 
    } // prifle end*/
    public getSurveyEmployeeOne(survey) {
        const getSurveyEmployeeOneObservable = new Observable(observer => {
            this.http.get(`${environment.API_HOST}/survey/${survey}`)
            .subscribe(response => {
                observer.next(response);
            }, error => {
                observer.next(error.reason);
            })
        });
        return getSurveyEmployeeOneObservable; 
    } // prifle end*/
    public updateSurvey(survey){
        const updateSurveyObservable = new Observable(observer => {
            this.http.post(`${environment.API_HOST}/survey`,survey)
            .subscribe(response => {
                observer.next(response);
            }, error => {
                observer.error(error.reason);
            })
        });
        return updateSurveyObservable;  
    }
} // class

// Mon Apr 15 2019 13:33:13 GMT-0600